[
 {
  "slug": "the-gentlemen-s3",
  "title": "The Gentlemen S3",
  "broadcaster": "Netflix",
  "dates": "Oct 2026 – Current",
  "role": "Assistant Set Decorator"
 },
 {
  "slug": "lineage",
  "title": "Lineage",
  "broadcaster": "BBC Films",
  "dates": "July 2026 – Sept 2026",
  "role": "Junior Assistant Set Dec"
 },
 {
  "slug": "silo-s4",
  "title": "Silo S4",
  "broadcaster": "Apple TV",
  "dates": "May 2025 – Jan 2026",
  "role": "Action Prop Buyer"
 },
 {
  "slug": "silo-s3",
  "title": "Silo S3",
  "broadcaster": "Apple TV",
  "dates": "July 2024 – May 2025",
  "role": "Action Prop Buyer"
 },
 {
  "slug": "the-hack",
  "title": "The Hack",
  "broadcaster": "ITV",
  "dates": "Oct 2023 – Jun 2024",
  "role": "Junior Assistant Set Dec"
 },
 {
  "slug": "joy",
  "title": "Joy",
  "broadcaster": "Netflix",
  "dates": "Sept 2023 – Oct 2023",
  "role": "Petty Cash Buyer"
 },
 {
  "slug": "prime-target",
  "title": "Prime Target",
  "broadcaster": "Apple TV",
  "dates": "June 2023",
  "role": "Action Prop Buyer"
 },
 {
  "slug": "all-the-devils-are-here",
  "title": "All the Devils Are Here",
  "broadcaster": "Amazon",
  "dates": "Mar 2023 – June 2023",
  "role": "Junior Assistant Set Dec"
 },
 {
  "slug": "the-six-triple-eight",
  "title": "The Six Triple Eight",
  "broadcaster": "Netflix",
  "dates": "Nov 2022 – Mar 2023",
  "role": "Junior Assistant Set Decorator"
 },
 {
  "slug": "motherland-xmas-2022",
  "title": "Motherland Xmas 2022",
  "broadcaster": "BBC",
  "dates": "Oct 2022 – Nov 2022",
  "role": "Production Buyer"
 },
 {
  "slug": "you-s4",
  "title": "You S4",
  "broadcaster": "Netflix",
  "dates": "Jan 2022 – Aug 2022",
  "role": "Petty Cash Buyer"
 },
 {
  "slug": "his-dark-materials",
  "title": "His Dark Materials",
  "broadcaster": "BBC",
  "dates": "Jan 2021 – Dec 2021",
  "role": "Petty Cash Buyer"
 },
 {
  "slug": "whitstable-pearl",
  "title": "Whitstable Pearl",
  "broadcaster": "Acorn TV",
  "dates": "Aug 2020 – Jan 2021",
  "role": "Art Department Assistant"
 }
]